import React from 'react';
import { ComponentPropsWithoutRef } from 'react';
import { cx } from '@linaria/atomic';
import { Text } from '../../';
import { formatDate } from '../../../helpers';
import { CaretDownIconSmall, CaretUpIconSmall } from '../../../icon';
import { NakedButton } from '../../../naked';
import { SelectByType } from '../calendar-types';
import { CalendarControlsStyles } from '../layouts/dialog/styles';
import { useCalendarState } from '../provider';
import { getDecadeRange } from '../provider/reducer';
import type { BaseAtomProps } from './calendar-atom.types';

type Props = BaseAtomProps & {
  month: number;
  year: number;
};
type CalendarTitleProps = Props & Omit<ComponentPropsWithoutRef<'button'>, keyof Props>;

const formatTitle = (month: number, year: number, selectBy: SelectByType) => {
  switch (selectBy) {
    case 'day':
      return formatDate(new Date(year, month), 'MMMM YYYY');
    case 'month':
      return year;
    case 'year': {
      const decade = getDecadeRange(year);
      return `${decade[0]} - ${decade[decade.length - 1]}`;
    }
  }
};

export const CalendarTitle = ({ className, month, year, ...rest }: CalendarTitleProps) => {
  const { selectByBtnProps, selectBy } = useCalendarState();
  const titleHeader = CalendarControlsStyles.titleHeader;
  return (
    <React.Fragment>
      {selectBy !== 'year' ? (
        <NakedButton {...selectByBtnProps} className={titleHeader} type='button' {...rest}>
          <time dateTime={`${year}-${month}`} className={cx('cal__month-name', className)}>
            {formatTitle(month, year, selectBy)}
          </time>
          <span>
            <CaretUpIconSmall color='light' />
            <CaretDownIconSmall color='light' />
          </span>
        </NakedButton>
      ) : (
        <Text as='h4' weight='bold' className={cx('cal__month-name', className)}>
          {formatTitle(month, year, selectBy)}
        </Text>
      )}
    </React.Fragment>
  );
};
